export default __webpack_public_path__ + "static/media/no-receipt.c304d2b5.png";